import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import './header.css';
import { links } from '../../json/headerLinks';

const Header = () => {
    const [overlay, setOverlay] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleMouseEnter = (submenu) => {
    setActiveSubmenu(submenu);
  }
  const handleMouseLeave = () => {
    setActiveSubmenu(null);
  }

  const hideMenu = () => {
    const div =  document.getElementById('navbarNav');
    div.classList.remove('show');
    setOverlay(false);
  }
  
  return (
    <>
        {
            overlay ? <div onClick={()=>{setOverlay(!overlay)}} className='overlay-menu' data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav"></div> : null
        }
        <div id='header'>
<nav className="navbar navbar-expand-lg navbar-dark bg-gob">
                <div className="container-fluid">
                    <Link className="nav-link active" aria-current="page" to="/">
                        {
                            // isMobile ? <img className='logo-menu' src='https://cdn.hidalgo.gob.mx/gobierno/images/secretarias/vertical/campo.svg'/> : <span>SECRETARÍA DE AGRICULTURA Y DESARROLLO RURAL</span>
                            isMobile ? <img className='logo-menu' src='https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Interes/Campo.png'/> : <span>SECRETARÍA DE AGRICULTURA Y DESARROLLO RURAL</span>
                        }
                    </Link>
                    <span className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={()=>{setOverlay(true)}} style={{color: "white"}} viewBox="0 0 32 32">
                        MENÚ
                    </span>
                    <div className="collapse navbar-collapse second-navbar-gob" id="navbarNav">
                        <ul id='menu-list' className="navbar-nav"
                            onClick={() => {setActiveSubmenu(null); hideMenu()}}>
                            <li className="nav-item">
                                <Link to="/" className="nav-link">Inicio</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Contacto" className="nav-link">Contacto</Link>
                            </li>
                            {
                                links.map((item, index)=>(
                                    <li key={ index } className="nav-item dropdown"
                                        onMouseEnter={() => handleMouseEnter( item.nombre )}
                                        onMouseLeave={handleMouseLeave}>
                                        <Link to={ item.link } 
                                            className="nav-link"
                                            onClick={() =>{setActiveSubmenu(null) }}>{ item.nombre }</Link>
                                        <ol className={`dropdown-menu ${activeSubmenu ===  item.nombre  ? "show" : ""}`} aria-labelledby="navbarDropdownMenuLink">
                                            {
                                                item.submenu.map((item, index)=>(
                                                    <li key={ index }><Link className="dropdown-item" to={ item.subMenuUrl }>{ item.subMenuNombre }</Link></li>
                                                ))
                                            }
                                        </ol>
                                        <span className={`triangle ${activeSubmenu ===  item.nombre  ? "show" : ""}`} />
                                    </li>
                                ))
                            }
                            {/* <li className="nav-item">
                                <Link to="/CampoDigital" className="nav-link">Ventanilla</Link>
                            </li>  */}
                            {/* <li className="nav-item">
                                <Link to="/Informe" className="nav-link">2do Informe</Link>
                            </li>  */}
                             <li className="nav-item dropdown">
                                <Link to="/Agenda" className="nav-link">Agenda</Link>
                            </li> 
                            <li className="nav-item">
                                <Link to="/LigasInteres" className="nav-link">Interés</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Servicios" className="nav-link">Servicios</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Convocatorias" className="nav-link">Convocatorias</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Beneficiarios" className="nav-link">Beneficiarios</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </>
  )
}

export default Header